"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

//fa-navicon
var MainMenu = function MainMenu() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M476,384.3V421c0,5-1.9,9.3-5.4,12.9s-7.9,5.4-12.9,5.4H54.3c-5,0-9.3-1.9-12.9-5.4C37.9,430.3,36,426,36,421v-36.7c0-5,1.9-9.3,5.4-12.9c3.6-3.6,7.9-5.4,12.9-5.4h403.3c5,0,9.3,1.9,12.9,5.4S476,379.3,476,384.3z M476,237.7v36.7c0,5-1.9,9.3-5.4,12.9s-7.9,5.4-12.9,5.4H54.3c-5,0-9.3-1.9-12.9-5.4c-3.6-3.6-5.4-7.9-5.4-12.9v-36.7c0-5,1.9-9.3,5.4-12.9c3.6-3.6,7.9-5.4,12.9-5.4h403.3c5,0,9.3,1.9,12.9,5.4C474.1,228.4,476,232.7,476,237.7z M476,91v36.7c0,5-1.9,9.3-5.4,12.9s-7.9,5.4-12.9,5.4H54.3c-5,0-9.3-1.9-12.9-5.4c-3.6-3.6-5.4-7.9-5.4-12.9V91c0-5,1.9-9.3,5.4-12.9c3.6-3.6,7.9-5.4,12.9-5.4h403.3c5,0,9.3,1.9,12.9,5.4C474.1,81.7,476,86,476,91z"
  }));
};

MainMenu.displayName = 'MainMenu';
var _default = MainMenu;
exports["default"] = _default;
MainMenu.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MainMenu"
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/MainMenu.js"] = {
    name: "MainMenu",
    docgenInfo: MainMenu.__docgenInfo,
    path: "src/MainMenu.js"
  };
}